import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import MainNavigation from "./header/MainNavigation";
import gsap from "gsap";
import SplinePart from "../components/SplinePart";
import { useRef } from "react";
import { useSpline } from "../context/SplineContext";
import { ScrollTrigger } from "gsap/all";
import ScrollToHashElement from "../components/ScrollToHashElement";
import Preloader from "../components/PreloaderAnim";

import MouseFollower from "mouse-follower";
MouseFollower.registerGSAP(gsap);

const cursor = new MouseFollower();

export default function RootLayout() {
  const location = useLocation();
  const isHomepage = location.pathname === "/";
  const splineReg = useRef();
  const { setSplineData } = useSpline();

  useEffect(() => {
    if (location.pathname !== "/") {
      window.awakenTimeline?.scrollTrigger?.kill();
      console.log("kill scrolltriger");
    }

    ScrollTrigger.refresh();
  }, [location.pathname]);

  useEffect(() => {
    const headings = document.querySelectorAll("h1, h2, h3, h4, h5, h6");

    headings.forEach((el) => {
      el.addEventListener("mouseenter", () => {
        cursor.addState("-scale");
      });
      el.addEventListener("mouseleave", () => {
        cursor.removeState("-scale");
      });
    });

    return () => {
      headings.forEach((el) => {
        el.removeEventListener("mouseenter", () => {});
        el.removeEventListener("mouseleave", () => {});
      });
    };
  }, [location.pathname]);

  return (
    <>
      <ScrollToHashElement />
      <SplinePart splineRef={splineReg} onSplineReady={setSplineData} />
      <Preloader />
      <div className="fl-page">
        <MainNavigation />
        <main>
          <Outlet />
        </main>
      </div>
    </>
  );
}
